import { OrganizationUserDto } from "../../common/service/server/dto/UserDto";

export const getUserFullName = (user: OrganizationUserDto) => {
  return user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;
};
